import { useMutation } from "react-query";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface UseClickButtonProps {
  onError: (error: unknown) => void;
  onSuccess: () => void;
}

interface ClickButtonParams {
  conversationId: string;
  event: string;
  messageId: string;
}

export const useClickButton = ({ onSuccess, onError }: UseClickButtonProps) =>
  useMutation<unknown, unknown, ClickButtonParams>({
    mutationFn: async ({
      conversationId,
      event,
      messageId,
    }: ClickButtonParams) =>
      reactQueryPost(
        internalApi.helpWidget.clickButton({
          conversationId,
          messageId,
        }),
        {
          event,
        },
      ),
    onSuccess,
    onError,
  });
